import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

const CaregiverNameView = (props) => {
  const {
    caregiverData,
    setIsEditing,
  } = props;

  const caregiverName = caregiverData.caregiverName;

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Typography sx={{fontSize: '28px', fontWeight: 400}}>
        {caregiverName}
      </Typography>
    </Box>
  );
};

CaregiverNameView.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverNameView);
